// extracted by mini-css-extract-plugin
export default {"preview":"StoryPreview_preview__+gVnr","preview__close":"StoryPreview_preview__close__c9k8T","preview__send":"StoryPreview_preview__send__0nVZJ"};